// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"c7b96df4","463":"8ce39c52"}[chunkId] + ".chunk.css";
};